import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface ConvertShelfType {
  id: number
  branchCode: SystemCode
  shelfType: SystemCode
  collectionType: SystemCode
  mark: string
  startNdc: string
  startBook: string
  startSub: string
  endNdc: string
  endBook: string
  endSub: string
  revision: number
}

export function ConvertShelfTypeFromJSON(json: any): ConvertShelfType {
  return {
    id: exists(json, 'id') ? json.id : 0,
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    mark: exists(json, 'mark') ? json.mark : '',
    startNdc: exists(json, 'start_ndc') ? json.start_ndc : '',
    startBook: exists(json, 'start_book') ? json.start_book : '',
    startSub: exists(json, 'start_sub') ? json.start_sub : '',
    endNdc: exists(json, 'end_ndc') ? json.end_ndc : '',
    endBook: exists(json, 'end_book') ? json.end_book : '',
    endSub: exists(json, 'end_sub') ? json.end_sub : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
